const imageObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      const lazyImage = entry.target;
      lazyImage.src = lazyImage.dataset.src;
      if (lazyImage.dataset.srcset) lazyImage.srcset = lazyImage.dataset.srcset;
    }
  });
});

window.initLazy = (selector = "[data-lazy") => {
  const imagesArr = document.querySelectorAll(selector);
  imagesArr.forEach((img) => {
    imageObserver.observe(img);
  });
};

window.initLazy();
